import { Col, Divider, Row, Typography } from "antd"
import { ApprovedIntervalBasedPaymentSummary } from "../../../domain/proposals/paymentSummary"
import PaymentSection from "./PaymentSection"
import { WorkareaGroup } from "../../../domain/workareas/group"
import { centsToDollarsDisplay } from "../../displayFormatters"
import dayjs from "dayjs"

type Props = {
  summary: ApprovedIntervalBasedPaymentSummary
  workareaGroups: WorkareaGroup[]
}

const IntervalBased = ({summary, workareaGroups}: Props) => {
  const groupNames = workareaGroups.filter(x => summary.workareaGroupIds.some(y => y == x.id)).map(x => x.name)
  const divider = <Divider style={{margin: '8px 0 8px 0'}}/>
  const perInvoiceWithSalesTax = summary.perInvoiceAmount + summary.perInvoiceSalesTax
  
  return <PaymentSection title="Interval-based Invoicing Schedule">
    <Row>
      <Col span={24}>Pertains to: <strong>{groupNames.join(', ')}</strong></Col>
    </Row>
    {divider}
    <Row>
      <Col span={12}>{summary.scheduleText}</Col>
      <Col span={12} style={{textAlign: 'right'}}>
        <Typography.Text type="secondary">
          {summary.totalPayments} payments of
        </Typography.Text> {centsToDollarsDisplay(summary.perInvoiceAmount)}
      </Col>
    </Row>
    <Row>
      <Col span={12}>
        {summary.startDate && <Typography.Text type="secondary">Starting {dayjs(summary.startDate).format('MMM D, YYYY')}</Typography.Text>}
      </Col>
      <Col span={12} style={{textAlign: 'right'}}>
        {summary.perInvoiceSalesTax > 0 && <Typography.Text type="secondary">
          {centsToDollarsDisplay(perInvoiceWithSalesTax)} with sales tax
        </Typography.Text>}
      </Col>
    </Row>
    {divider}
    <Row style={{fontSize: '1.2em', fontWeight: 'bold'}}>
      <Col span={12}>Total</Col>
      <Col span={12} style={{textAlign: 'right'}}>{centsToDollarsDisplay(summary.estimatedTotal)}</Col>
    </Row>
    <Row>
      <Col span={12}></Col>
      <Col span={12} style={{textAlign: 'right'}}>
        
      </Col>
    </Row>
  </PaymentSection>
}

export default IntervalBased